<template>
  <div class="sign-up-photo">
    <header>
    <div class="grid-container header">
      <img class="logo" src="../../assets/images/global/logo.svg">
      <router-link class="btn bg-one active" to="login">Log In</router-link>
    </div>
    </header>
    <section class="instructions">
      <div class="grid-container">
        <div class="col-4">
          <h2><span class="bold">Add a picture to your profile.</span> The most popular profiles usually have images.</h2>
        </div>
      </div>
    </section>
    <section>
      <div class="grid-container">
        <div class="row">
          <div class="shift-4 col-4">

            <profile-image></profile-image>
            

          </div>
        </div>
      </div>
    </section>

    <section class="sign-up-navigation">
    <div class="grid-container">
      <a href="#" v-on:click.stop.prevent="stepBack" class="link-back">Change Information</a>
      <a href="#" v-on:click.stop.prevent="progress" class="btn btn-big bg-four active">Next</a>
    </div>
    </section>
  </div>
</template>

<script>
import { db, auth, storage } from '@/firebase'

import ProfileImage from '@/components/register/ProfileImage'

export default {
  name: 'Register',
  data () {
    return {
      imageToUpload: null,
      croppie: null
    }
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    progress () {
      let user = auth.currentUser
      if (!this.croppie) {
        // If no image uploaded
        db.ref('users-registration/' + user.uid).update({
          profileimg: 'default'
        })
      } else {
        this.croppie.result({
          type: 'blob',
          size: { width: 500, height: 500 },
          quality: 0.6,
          circle: false,
          format: 'jpeg'
        }).then(response => {
          console.log(response)
          this.imageToUpload = response
          let uploadTask = storage.child('profile-images/' + user.uid)
          uploadTask.put(response).then(function (snapshot) {
            let profileimg = snapshot.downloadURL
            db.ref('users-registration/' + user.uid).update({
              profileimg: profileimg
            })
          })
        })
      }

      // Give the user +5 rep and then move on
      let parent = this
      let repData = {}
      repData[user.uid] = 5
      console.log(repData)
      db.ref('user-meta/reputation/').update(repData, function () {
        // On complete
        console.log('saved')
        parent.$parent.currentStep++
      })
    }
  },
  components: {
    ProfileImage
  }
}
</script>

<style>
.cropit-preview {
  /* You can specify preview size in CSS */
  width: 960px;
  height: 200px;
  border: 1px solid red;
}
</style>




// WEBPACK FOOTER //
// Register-Step-4.vue?9e5dd09c